export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/Line-ff837d19361e71ac5c52c2892ea9d75e.svg";